import React, {Component} from 'react';
import { Link } from "react-router-dom";

import './Modal.css';

export default class Modal extends Component {
    render() {
        return (
            <div className="modal visible" data-content-name="licence">
                <div className="content">
                    <h2>Usage Licence</h2>
                    <Link className="close" to="/">Close popup</Link>
                    <p>All Softies icons and the website are the work of <a href="http://robbiepearce.com">Robbie Pearce</a>. Use of the Softies icons must adhere to the following licence terms.</p>
                    <p>You are free to use the icons for both personal, and commercial projects. You <strong>may not</strong> redistribute these icons, please link to the original download page.</p>
                    <p>You are free to modify the icons for your own use, however you may not redistribute modified icons, or claim any Softies icons as you own.</p>
                    <p>Sofites, Copyright &copy; 2017 Robbie Pearce.</p>
                </div>
            </div>
        )
    }

}
